const Certification = () => {
  return (
    <div>Certification</div>
  )
}
export default Certification